// sideBar/menuConfig.ts

// Interfaces
export interface IconTree {
  tag: string;
  attr?: {[key: string]: string};
  child?: {tag: string; attr?: {[key: string]: string}}[];
}

export interface MenuItemConfig {
  id: string;
  type: 'route' | 'link';
  order: number;
  label: string;
  action: string;
  target?: '_blank' | '_self';
  roles?: number[];
  permissions?: string[];
  icon?: IconTree[] | null;
  model_id?: number;
}

export interface MenuConfig {
  id: string;
  name: string;
  positions: string[];
  items: MenuItemConfig[];
}

export const menuConfig: MenuConfig = {
  id: 'main',
  name: 'Main Menu',
  positions: ['sidebar'],
  items: [
    {
      id: 'wkd001',
      type: 'route',
      order: 1,
      label: 'Dashboard',
      action: '/',
      icon: [
        {
          tag: 'svg',
          attr: {
            viewBox: '0 0 20 20',
            fill: 'currentColor',
            className: 'w-20 h-20',
          },
          child: [
            {
              tag: 'path',
              attr: {
                d: 'M12 3s-6.186 5.34-9.643 8.232c-.203.184-.357.452-.357.768 0 .553.447 1 1 1h2v7c0 .553.447 1 1 1h3c.553 0 1-.448 1-1v-4h4v4c0 .552.447 1 1 1h3c.553 0 1-.447 1-1v-7h2c.553 0 1-.447 1-1 0-.316-.154-.584-.383-.768-3.433-2.892-9.617-8.232-9.617-8.232z',
              },
            },
          ],
        },
      ],
    },
    {
      id: 'wkd002',
      type: 'route',
      order: 2,
      label: 'Documents',
      action: '/documents',
      icon: [
        {
          tag: 'svg',
          attr: {
            viewBox: '0 0 24 24',
            fill: 'currentColor',
            className: 'w-20 h-20',
          },
          child: [
            {
              tag: 'path',
              attr: {
                d: 'M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H6z',
              },
            },
          ],
        },
      ],
    },
    {
      id: 'wkd003',
      type: 'route',
      order: 3,
      label: 'Signature Documents',
      action: '/signature-documents',
      icon: [
        {
          tag: 'svg',
          attr: {
            viewBox: '0 0 20 20',
            fill: 'currentColor',
            className: 'w-20 h-20',
          },
          child: [
            {
              tag: 'path',
              attr: {
                d: 'M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z',
              },
            },
          ],
        },
      ],
    },
    {
      id: 'wkd004',
      type: 'route',
      order: 4,
      label: 'Minted',
      action: '/minted',
      icon: [
        {
          tag: 'svg',
          attr: {
            viewBox: '0 0 24 24',
            fill: 'currentColor',
            className: 'w-20 h-20',
          },
          child: [
            {
              tag: 'path',
              attr: {
                d: 'M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 18c-3.87-.78-7-4.42-7-8.5V8.3l7-3.5 7 3.5v3.2c0 4.08-3.13 7.72-7 8.5z',
              },
            },
            {
              tag: 'circle',
              attr: {
                cx: '12',
                cy: '12',
                r: '3',
              },
            },
          ],
        },
      ],
    },
    {
      id: 'wkd005',
      type: 'route',
      order: 5,
      label: 'Transactions',
      action: '/transactions',
      icon: [
        {
          tag: 'svg',
          attr: {
            viewBox: '0 0 24 24',
            fill: 'currentColor',
            className: 'w-20 h-20',
          },
          child: [
            {
              tag: 'path',
              attr: {
                d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z',
              },
            },
          ],
        },
      ],
    },
    {
      id: 'wkd006',
      type: 'route',
      order: 6,
      label: 'Payment History',
      action: '/payment-history',
      icon: [
        {
          tag: 'svg',
          attr: {
            viewBox: '0 0 24 24',
            fill: 'currentColor',
            className: 'w-20 h-20',
          },
          child: [
            {
              tag: 'path',
              attr: {
                d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z',
              },
            },
          ],
        },
      ],
    },
    // {
    //   id: 'wkd004',
    //   type: 'route',
    //   order: 4,
    //   label: 'Wallet',
    //   action: '/wallet',
    //   icon: [
    //     {
    //       tag: 'svg',
    //       attr: {
    //         viewBox: '0 0 20 20',
    //         fill: 'currentColor',
    //         className: 'w-20 h-20',
    //       },
    //       child: [
    //         {
    //           tag: 'path',
    //           attr: {
    //             d: 'M4 4h12v2H4V4zm0 4h12v8H4V8zm2 2v2h8v-2H6z',
    //           },
    //         },
    //       ],
    //     },
    //   ],
    // },
    // {
    //   id: 'wkd005',
    //   type: 'route',
    //   order: 5,
    //   label: 'Transaction',
    //   action: '/transaction',
    //   icon: [
    //     {
    //       tag: 'svg',
    //       attr: {
    //         viewBox: '0 0 24 24',
    //         fill: 'currentColor',
    //         className: 'w-20 h-20',
    //       },
    //       child: [
    //         {
    //           tag: 'path',
    //           attr: {
    //             d: 'M3 10h18v2H3v-2zm0 4h12v2H3v-2z',
    //           },
    //         },
    //       ],
    //     },
    //   ],
    // },
  ],
};
